import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { AbstractSandbox } from 'app/core/sandboxes/abstract.sandbox';
import { AzureMonitoringService } from '../services/AzureMonitoringService';
import * as fromRoot from '../store';
import { StockCountFilter } from '../store/stock-count/stock-count-filter.interface';
import * as stockCountActions from 'app/core/store/stock-count/stock-count.actions';
import { GetStockCountMaterialList, StockCountItem, StockCountState, TOstockCount } from '../store/stock-count/stock-count.interface';
import { goAction } from '../store/router/router.actions';
import { first } from 'rxjs/operators';
import { NotificationService } from 'app/core/services/notification.service';

@Injectable({ providedIn: 'root' })
export class StockCountSandbox extends AbstractSandbox {

  isLoading$ = this.store.select(state => state.stockCount.stockCounts.loading);

  public openStockCount(stockCount: StockCountItem) {
    if (stockCount && stockCount.stockCountNo) {
      this.store.dispatch(goAction({ path: `stock-count/detail/${stockCount.stockCountNo}` }));
    }
  }

  public filterStockCounts(filter: { value: StockCountFilter; valid: boolean }) {
    if (filter && filter.valid) {
      this.store.dispatch(new stockCountActions.StockCountsFilterValuesLoadAction(filter.value));
    }
  }

  public pageSizeUpdate(pageSize: number) {
    this.store.dispatch(new stockCountActions.StockCountsPageSizeUpdate(pageSize));
  }

  public pageNumberUpdate(pageNumber: number) {
    this.store.dispatch(new stockCountActions.StockCountsPageNumberUpdate(pageNumber));
  }

  getStockCountDetail(stockCountNumber: number) {
    // dispatch action to load details
    this.store.dispatch(new stockCountActions.StockCountsDetailLoadAction(stockCountNumber));
  }

  getStockCountOrderList(shiptoId: string) {
    // dispatch action to load details
    this.store.dispatch(new stockCountActions.StockCountsOrderListLoadAction(shiptoId));
  }

  getStockCountMaterials(getMaterialList: GetStockCountMaterialList) {
    // dispatch action to load details
    this.store.dispatch(new stockCountActions.StockCountsMaterialListLoadAction(getMaterialList));
  }

  createStockCount(mappedList: TOstockCount) {
    this.store.dispatch(new stockCountActions.StockCountsCreateAction(mappedList));
  }

  getShipTos(customerNr: string) {
    this.store
      .select('stockCount')
      .pipe(first())
      .subscribe((stockCount: StockCountState) => {
        if (!stockCount.shipTos.data) {
          this.store.dispatch(new stockCountActions.StockCountsShipToLoadAction(customerNr));
        }
      });
  }

  cancelCreate() {
    this.store.dispatch(goAction({ path: `stock-count/` }));
    this.resetCreate();
  }

  resetCreate() {
    this.store.dispatch(new stockCountActions.StockCountsCreateCanceled());
  }

  print() {
    this.store.dispatch(goAction({ path: `stock-count/print` }));
  }

  printStockCounty(shipToId: string) {
    this.store.dispatch(new stockCountActions.StockCountsPrintLoadAction(shipToId));
  }

  goToCreate() {
    this.store.dispatch(goAction({ path: `stock-count/new` }));
  }

  private cleanObjectOfEmptyValues(obj): any {
    Object.keys(obj).forEach(key => !obj[key] && delete obj[key]);
    return obj;
  }
}
